export default "__VITE_ASSET__DBCGtMAt__"